/**
 * @owner @Appboy/whats-app
 */

import { z } from "zod";

const textReplyButtonSchema = z.object({
  type: z.literal("textReplyButton"),
  text: z.string(),
  id: z.string().optional(),
});

const appButtonSchema = z.object({
  type: z.literal("appButton"),
  text: z.string(),
  androidScheme: z.string().nullable().optional(),
  iosScheme: z.string().nullable().optional(),
  id: z.string().optional(),
});

const webButtonSchema = z.object({
  type: z.literal("webButton"),
  text: z.string(),
  websiteUrl: z.string(),
  id: z.string().optional(),
});

const kakaoButtonSchema = z.discriminatedUnion("type", [textReplyButtonSchema, appButtonSchema, webButtonSchema]);

const listItemSchema = z.object({
  title: z.string(),
  imageUrl: z.string(),
  websiteUrl: z.string(),
});

export const kakaoMessageDetailsSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("text"),
    text: z.string(),
    buttons: z.array(kakaoButtonSchema),
  }),
  z.object({
    type: z.literal("image"),
    text: z.string(),
    imageUrl: z.string(),
    websiteUrl: z.string().nullable().optional(),
    imageLayout: z.enum(["narrow", "wide"]),
    buttons: z.array(kakaoButtonSchema),
  }),
  z.object({
    type: z.literal("list"),
    header: z.string(),
    featuredItem: listItemSchema,
    additionalItems: z.array(listItemSchema),
    buttons: z.array(kakaoButtonSchema),
  }),
  z.object({
    type: z.literal("carousel"),
    elements: z.array(
      z.object({
        header: z.string(),
        message: z.string(),
        imageUrl: z.string(),
        websiteUrl: z.string().nullable().optional(),
        buttons: z.array(kakaoButtonSchema),
      })
    ),
  }),
]);
